import type React from 'react';

/** Visibilidade do acompanhamento — espelha o `visibilityMode` do co-atendimento. */
export type MonitoringMode = 'visible-to-attendant' | 'visible-to-both' | 'invisible-to-all';

export interface SilentMonitoringIndicatorProps {
  supervisorName: string;
  mode: MonitoringMode;
}

/**
 * Faixa que o ATENDENTE vê quando está sendo acompanhado — só em modos visíveis.
 * Em `invisible-to-all` não renderiza nada (regra do silêncio).
 * Convertido verbatim de design-references/brief-3/shared/badges-3.jsx:244-253.
 */
export function SilentMonitoringIndicator({
  supervisorName,
  mode,
}: SilentMonitoringIndicatorProps): React.JSX.Element | null {
  if (mode === 'invisible-to-all') return null;
  return (
    <div className={`silent-monitor silent-monitor--${mode}`}>
      <span className="silent-monitor__dot" aria-hidden="true" />
      {mode === 'visible-to-attendant' && <>{supervisorName} está acompanhando esta conversa</>}
      {mode === 'visible-to-both' && (
        <>
          Esta conversa está sendo acompanhada por <b>{supervisorName}</b> para fins de qualidade
        </>
      )}
    </div>
  );
}
